<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M2 2.87386V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V4.99997C14 4.44768 13.5523 3.99997 13 3.99997H3C2.44772 3.99997 2 3.55225 2 2.99997V1.99997C2 1.44768 2.44772 0.999969 3 0.999969H10.3802C10.9325 0.999969 11.3802 1.44768 11.3802 1.99997V3.9517"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M13.75 7.49997H11.5C10.6716 7.49997 10 8.17154 10 8.99997V8.99997C10 9.8284 10.6716 10.5 11.5 10.5H13.75"
        stroke="var(--icon-color)" />
</svg>
